import React from 'react';
import {
  PagedCollectionProvider,
  usePagedCollectionState,
  usePagedCollectionDispatch,
  initializeCollection,
} from 'Context/PagedCollectionContext';

const StateContext = React.createContext(undefined);
const DispatchContext = React.createContext(undefined);

const NoteListContextProvider = ({
  notesSelfLink,
  ...rest
}) => {
  return (
    <PagedCollectionProvider
      StateContext={StateContext}
      DispatchContext={DispatchContext}
      initialState={{
        collectionSelfLink: notesSelfLink,
      }}
      {...rest}
    />
  );
};

const initializeNoteListCollection = (dispatch, linkUrl) => {
  initializeCollection(dispatch, linkUrl);
};

const useNoteListDispatchContext = () => {
  const context = usePagedCollectionDispatch(DispatchContext);

  if (!context) throw new Error('useNoteListDispatchContext must be called from DispatchContext.Provider');

  return context;
};

const useNoteListStateContext = () => {
  const context = usePagedCollectionState(StateContext);

  if (!context) throw new Error('useNoteListDispatchContext must be called from StateContext.Provider');

  return context;
};

export {
  NoteListContextProvider,
  useNoteListDispatchContext,
  useNoteListStateContext,
  initializeNoteListCollection,
};
